import { Download, Eye } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader } from "../../components/ui/card";
import pdfImg from "../../images/icons/pdf.png";

interface PDFCardProps {
  title: string;
  size: string;
  file: string;
  depositDate: string;
  modificationDate: string;
  onDownload?: () => void;
  onPreview?: () => void;
}

export function PDFCard({
  title,
  size,
  file,
  depositDate,
  modificationDate,
  onDownload,
  onPreview,
}: PDFCardProps) {
  const openFile = (file: string) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/medias/acts/${encodeURIComponent(file)}`;
    window.open(fileUrl, "_blank");
  };

  const downloadFile = async (file: string) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/medias/acts/${encodeURIComponent(file)}`;

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Card className="w-full max-w-sm overflow-hidden">
      <CardHeader className="p-4">
        {/* Icon & Title in the Same Line */}
        <div className="flex items-center gap-2">
          {/* PDF Icon */}
          <div className="flex items-center justify-center flex-shrink-0 w-8 h-8">
            <img src={pdfImg} alt="PDF" className="object-contain w-8 h-8" />
          </div>

          {/* Title (Truncated for Long Texts) */}
          <h3
            className="text-xs font-semibold "
            style={{ overflowWrap: "anywhere" }}
          >
            {title}
          </h3>
        </div>

        {/* Download Button */}
        <Button
          variant="secondary"
          className="w-full mt-2 text-white bg-primary hover:bg-primary/80"
          onClick={() => downloadFile(file)}
        >
          <Download className="w-4 h-4 mr-2" />
          Télécharger
        </Button>
      </CardHeader>

      <CardContent>
        <div className="space-y-2 text-sm text-muted-foreground">
          <div className="flex justify-between">
            <span>Taille :</span>
            <span>{size}</span>
          </div>
          <div className="flex justify-between">
            <span>Date de dépôt:</span>
            <span>{depositDate}</span>
          </div>
          <div className="flex justify-between">
            <span>Date de modification:</span>
            <span>{modificationDate}</span>
          </div>
          <Button
            variant="ghost"
            className="w-full mt-3 hover:bg-primary hover:text-white"
            onClick={() => openFile(file)}
          >
            <Eye className="w-4 h-4 mr-2" />
            Aperçu
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
